// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__1Rnm8","label":"styles_label__238n5","btn_wrapper":"styles_btn_wrapper__YiiTy","active":"styles_active__-w8aB","one_btn":"styles_one_btn__m6Kpd"};